import { useState, useEffect } from 'react'

const useClassificationConfig = () => {
    const [config, setConfig] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        fetch('/v0/classification_config', { credentials: 'same-origin' })
            .then(response => response.json())
            .then(json => {
                if (json.result) {
                    setConfig(json.result)
                }
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            })
    }, [])

    return { config, loading }
}

export default useClassificationConfig
